/**
 * 65.49 step 2: HUD view B in play — the 2D canvas over the view that ui/antiDropshipMissileHud.ts draws on, shown while
 * the player's anti-dropship missile is up (the host passes the frame, null otherwise). The canvas follows the window and
 * takes no input; nothing is drawn, and nothing costs, while it is hidden.
 */
import { drawAntiDropshipMissileHud, type AntiDropshipMissileHudFrame } from './antiDropshipMissileHud';

export class AntiDropshipMissileOverlay {
  private canvas: HTMLCanvasElement | null = null;
  private g: CanvasRenderingContext2D | null = null;
  private shown = false;

  /** This frame's lock as the HUD reads it, or null to hide it. */
  update(frame: AntiDropshipMissileHudFrame | null): void {
    if (!frame) { if (this.shown && this.canvas) { this.canvas.style.display = 'none'; this.shown = false; } return; }
    if (!this.canvas) {
      this.canvas = document.createElement('canvas');
      this.canvas.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;pointer-events:none;z-index:6';
      document.body.appendChild(this.canvas);
      this.g = this.canvas.getContext('2d');
    }
    const w = window.innerWidth, h = window.innerHeight, dpr = window.devicePixelRatio || 1;
    if (this.canvas.width !== Math.round(w * dpr) || this.canvas.height !== Math.round(h * dpr)) { this.canvas.width = Math.round(w * dpr); this.canvas.height = Math.round(h * dpr); }
    if (!this.shown) { this.canvas.style.display = ''; this.shown = true; }
    const g = this.g;
    if (!g) return;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);
    drawAntiDropshipMissileHud(g, frame, w, h);
  }

  dispose(): void { this.canvas?.remove(); this.canvas = null; this.g = null; this.shown = false; }
}
